import script from "./SitePageEditorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SitePageEditorLayout.vue?vue&type=script&setup=true&lang=js"

import "./SitePageEditorLayout.vue?vue&type=style&index=0&id=215f2580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215f2580"]])

export default __exports__